/* Light YouTube Embeds by @labnol adapted by WSA - VH fix 25 aug 2026: 16:9 thumb, responsive, keyboard accessible */
document.addEventListener("DOMContentLoaded", function () {
    var div, n, v = document.getElementsByClassName("youtube-player");
    for (n = 0; n < v.length; n++) {
        div = document.createElement("div");
        div.setAttribute("data-id", v[n].dataset.id);
        div.setAttribute("role", "button");
        div.setAttribute("tabindex", "0");
        div.setAttribute("aria-label", v[n].dataset.label || "Play video");
        div.innerHTML = labnolThumb(v[n].dataset.id);
        div.onclick = labnolIframe;
        div.onkeydown = function (e) {
            if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                labnolIframe.call(this);
            }
        };
        v[n].appendChild(div);
    }
});

function labnolThumb(id) {
    var thumb = '<img width="560" height="315" loading="lazy" alt="" style="width:100%;height:auto;aspect-ratio:16/9;object-fit:cover;display:block" src="https://i.ytimg.com/vi/ID/hqdefault.jpg" onerror="this.onerror=null;this.src=\'https://i.ytimg.com/vi/ID/hqdefault.jpg\'">',
        play = '<div class="play"></div>';
    return thumb.split("ID").join(id) + play;
}

function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?rel=0&showinfo=1&vq=720&autoplay=1";
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture");
    iframe.setAttribute("title", this.getAttribute("aria-label") || "YouTube video player");
    iframe.setAttribute("loading", "lazy");
    iframe.style.width = "100%";
    iframe.style.aspectRatio = "16 / 9";
    iframe.style.height = "auto";
    iframe.style.border = "0";
    this.parentNode.replaceChild(iframe, this);
}
